import { render, staticRenderFns } from "./Yeji.vue?vue&type=template&id=16cf10fe&scoped=true&"
import script from "./Yeji.vue?vue&type=script&lang=js&"
export * from "./Yeji.vue?vue&type=script&lang=js&"
import style0 from "./Yeji.vue?vue&type=style&index=0&id=16cf10fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf10fe",
  null
  
)

export default component.exports